import {settingsRoutes, snapshotsRoutes} from '@/routes/constants/agency/'

import { RouteConfig } from 'vue-router'
import { requireAuth } from '../auth'

const AccountSnapshots = () =>
  import(
    /* webpackChunkName: "account-snapshots" */ '@/pmd/pages/agency/AccountSnapshotsV2.vue'
  ).then(m => m.default)

export const snapshots: RouteConfig[] = [
  {
    path: '/snapshots',
    name: snapshotsRoutes.default,
    component: AccountSnapshots,
    beforeEnter: requireAuth,
    children: [
      {
        path: 'import/:share_id',
        name: snapshotsRoutes.import,
        redirect: () => {
          return { name: settingsRoutes.snapshot.importAccountTemplate }
        },
      },
      {
        path: ':type',
        name: snapshotsRoutes.type,
        component: AccountSnapshots,
        beforeEnter: requireAuth,
      },
      {
        path: ':snapshotId/edit',
        name: snapshotsRoutes.edit,
        component: AccountSnapshots,
        beforeEnter: requireAuth,
        meta: {
          hideTopBar: true,
        }
      },
      {
        path: ':snapshotId/history',
        name: snapshotsRoutes.history,
        component: AccountSnapshots,
        beforeEnter: requireAuth,
        meta: {
          hideTopBar: true,
        }
      }
    ],
  },
  
]